import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0033',
    ecrans: ['00-2'],
    params: ['id']
});
